<template>
  <div>
    <svg
      t="1508738709248"
      class="screenfull-svg"
      viewBox="0 0 128 128"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2069"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="128px"
      height="128px"
      @click="click"
    >
      <path
        fill="#2F3133"
        d="M123.216,91.628c-1.288-1.161-3.321-2.628-6.044-4.356c-0.841-0.533-1.335-1.448-1.322-2.445l0.004-0.362
			c0.088-7.409,0.22-18.608-1.744-29.988c-2.389-13.836-7.358-24.656-14.773-32.159c-5.844-5.913-13.229-9.828-22.049-11.709
			c-0.438-2.732-1.745-5.201-3.795-7.094C71.04,1.248,67.744,0,64.211,0c-3.531,0-6.827,1.248-9.28,3.513
			c-2.048,1.893-3.356,4.36-3.794,7.092c-8.779,1.871-16.111,5.756-21.892,11.621C12.48,39.236,12.902,68.314,13.129,83.936
			l0.012,0.854c0.015,0.997-0.502,1.94-1.348,2.467c-2.776,1.722-4.863,3.169-6.201,4.302C2.038,94.561,0,98.948,0,103.593
			c0,4.058,3.301,7.358,7.359,7.358h39.675c0.078,9.406,7.753,17.037,17.178,17.037s17.101-7.631,17.179-17.037H120.8
			c4.204,0,7.624-3.42,7.624-7.623C128.424,98.877,126.525,94.611,123.216,91.628z M64.211,5.727c2.088,0,4.004,0.708,5.395,1.993
			c0.609,0.563,1.092,1.208,1.441,1.92c-2.203-0.222-4.48-0.333-6.836-0.333c-2.346,0-4.615,0.11-6.809,0.33
			C58.576,7.282,61.118,5.727,64.211,5.727z M64.211,122.262c-6.267,0-11.372-5.061-11.449-11.311H75.66
			C75.583,117.201,70.479,122.262,64.211,122.262z M120.799,105.225H7.358c-0.9,0-1.632-0.731-1.632-1.632
			c0-2.956,1.298-5.749,3.563-7.663c1.11-0.938,3.02-2.254,5.524-3.809c2.543-1.578,4.097-4.418,4.054-7.412l-0.012-0.855
			c-0.214-14.785-0.614-42.305,14.469-57.607c7.333-7.44,17.725-11.212,30.887-11.212c13.188,0,23.635,3.804,31.051,11.308
			c6.576,6.655,11.02,16.448,13.204,29.108c1.875,10.862,1.746,21.745,1.661,28.946l-0.003,0.363
			c-0.036,2.994,1.451,5.739,3.976,7.346c2.385,1.514,4.26,2.854,5.281,3.776c2.105,1.9,3.316,4.614,3.316,7.446
			C122.697,104.374,121.846,105.225,120.799,105.225z"
      />
      <path
        fill="#409EFF"
        d="M55.336,21.045c-3.464,0-8.353,3.224-11.773,6.242c-2.835,2.501-7.783,7.609-9.068,13.715
			c-0.326,1.547,0.665,3.065,2.212,3.391c0.199,0.042,0.397,0.063,0.593,0.063c1.325,0,2.515-0.925,2.799-2.275
			c0.69-3.278,3.333-7.142,7.253-10.6c3.805-3.357,7.128-4.81,7.984-4.81c1.581,0,2.862-1.282,2.862-2.863
			C58.198,22.327,56.917,21.045,55.336,21.045z"
      />
    </svg>
  </div>
</template>

<script>

export default {
  name: 'Screenfull',
  props: {
    width: {
      type: Number,
      default: 22
    },
    height: {
      type: Number,
      default: 22
    },
    fill: {
      type: String,
      default: '#5a5e66'
    }
  },
  data() {
    return {
      isFullscreen: false
    }
  },
  methods: {
    click() {
      console.log('do nothing')
      /*
         if (!screenfull.enabled) {
         this.$message({
         message: 'you browser can not work',
         type: 'warning'
         })
         return false
         }
         screenfull.toggle()
         */
    }
  }
}
</script>

<style scoped>
  .screenfull-svg {
    display: inline-block;
    cursor: pointer;
    fill: #35628a;
    width: 20px;
    height: 20px;
    vertical-align: 10px;
  }
</style>
